import { 
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Renderer2,
  AfterViewInit,
  ChangeDetectionStrategy,
  ViewEncapsulation,
  Input,
  OnDestroy } from '@angular/core';
import { ViewService } from '../../view.service';
import { Select } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable, Subject } from 'rxjs';
import { HelpTypeEnum } from '../../models/help-type.enum';

@Component({
  selector: 'app-view-help',
  templateUrl: './view-help.component.html',
  styleUrls: ['./view-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ViewHelpComponent implements OnInit, AfterViewInit, OnDestroy {

  helpTypeEnum = HelpTypeEnum;

  // ---------- Child Elements ----------
  @ViewChild('viewHelp', { static: true })
  viewHelp: ElementRef;



  // ---------- Observables ---------
  @Select(ViewState.getCanTouch)
  canTouch$: Observable<boolean>;



  // ---------- Class Variables ----------
  @Input()
  activeTab: HelpTypeEnum = HelpTypeEnum.Basics;

  ngUnsubscribe = new Subject();



  // ---------- Layout ----------
  constructor(
    private renderer: Renderer2,
    private viewService: ViewService
  ) { }

  ngOnInit() {
    this.initWindowSizeObserver();
  }

  ngAfterViewInit() {
    this.updateViewHeight();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


  
  // ---------- Layout ----------
  initWindowSizeObserver() {
    this.renderer.listen('window', 'resize', () => {
      this.updateViewHeight();
    });
  }

  // Mobile devices have variable viewheight because the browser bar can scroll in and out of view
  // This workaround determines the available window space and uses that as a viewheight unit
  updateViewHeight() {
    const vh = this.viewService.getVH(false);
    this.viewHelp.nativeElement.style.setProperty('--vh', `${vh}px`);
  }



  // ---------- Interactions ----------
  handleCloseClick() {
    this.viewService.toggleHelp(false);
  }

  handleTabClick(tab: HelpTypeEnum) {
    this.activeTab = tab;
  }

}
